// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/4955db41/" + chunkId + "." + __webpack_require__.h() + ".v4955db41.js";
};